import Title, { TitleProps } from './Title';

export default Title;

export { TitleProps };
